import * as React from 'react';

import GlobalStyles from '@mui/material/GlobalStyles';
import firebase from '../../firebase/firebase'
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import TopBar from "../../components/TopBarV2";
import Box from "@mui/material/Box/Box";
import Button from "@mui/material/Button/Button";
import Grid from "@mui/material/Grid/Grid";
import PostNotification from '../../helpers/post-notification';
import {useIntl} from 'react-intl'

import {AuthUserContext} from "../../providers/AuthProvider";
import {useNavigate} from "react-router-dom";
import ScrollToTop from '../../utils/scrollTop';
import preTags from '../../utils/tags';
export default function ProjectTags() {
  const { user, profile, setProfile } = React.useContext(AuthUserContext);

  const {messages} = useIntl()
  const lis = profile?.tags?.projects || []
  const [tags, setTags] = React.useState(lis);
  // const preTags = [
  //  'Comedy',
  //   'Sci-Fi, Horror',
  //   'Romance',
  //   'Action',
  //    'Thriller',
  //    'Drama',
  //    'Mystery',
  //    'Crime',
  //    'Animation',
  //    ' Adventure',
  //    'Fantasy',
  //    'Comedy-Romance',
  //    'Superhero',
  //    'Short Film',
  //    'Anime',
  //     'All'
  // ];
  const navigator = useNavigate();

  const tagsStore = async () => {
    try {const userRef = firebase.firestore().collection('users')
           const userSnapshot = await userRef.where('uid', '==', user.uid).get();
      await userRef.doc(userSnapshot?.docs[0].id)
        .update({
          'tags.projects': tags,
        })
      const profileCopy = profile ;
      profileCopy.tags = profileCopy?.tags ? {...profileCopy?.tags, projects: tags}: {projects: tags};
      setProfile(profileCopy);
      const postId = await PostNotification({
        title: 'Investment Update',
        text: 'We are excited to inform that you can now start investing. See project here.',
        uid: profile.uid,
        createdBy:'self',
        link: '/investor/projects',
        });
      navigator('/investor/dashboard');
    } catch (e) {
      console.log(e);
    }
  }
  return (
    <>
    <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }}/>
      {/* Hero unit */}
      {/*<TopBar/>*/}
      <Container  maxWidth="lg" component="main" sx={{marginY: 5}}>
        <Box sx={{paddingX:2}}>
          <Typography variant="h4" align="left" color="text.primary" component="p">
            What genre are you interested in?
          </Typography>
          <Typography variant="h6" align="left" color="text.primary" component="p" sx={{ margin: '30px 0px', }}>
            This will allow us to show you the best<br/>matches for your <font color="#204488">interests</font>.

          </Typography>
        </Box>

      </Container>

      <Container maxWidth="lg" component="main">
        <Grid container spacing={2}  sx={{paddingX:2, pb: 3 }}>
          <Grid sx={{ mb :3, textAlign:'left'}} item xs={12}>
            <Typography variant={'h5'} >
              Add your <span style={{color:"#204488"}}>Tags</span>
            </Typography>
          </Grid>
          <Grid sx={{ml: 2, borderTop: '1px solid #204488'}} item xs={12}/>
          {
            preTags && preTags.map((d =>
            <Grid item xs={12} sm={4} md={3} lg={2} >
              <Button style={{width:"180px",height:"70px"}}
               variant={tags.length > 0 && tags.find((t) => t === d) ? 'contained':'outlined'}


                onClick={() => tags.length > 0 && tags.find((t) => t === d) ? setTags(tags.filter((t) => t !== d)) : setTags(d === 'All' ? [d]: tags.concat(d))} sx={{borderRadius: '5px', py: 2, textTransform:'capitalize', fontSize:16}} fullWidth>
                {d}
              </Button>
            </Grid>
          ))
          }
          <Grid sx={{ml: 2, borderBottom: '1px solid #204488', mt: 2 }} item xs={12}/>


        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          py={5}
        >
          <Button variant={'outlined'} sx={{py:1.5,px: 5,fontSize: 18, mr: 4,width:"180px"}} onClick={() => navigator(-1)}>Go Back
          </Button>
          <Button variant={'contained'} sx={{py:1.5,px: 5,fontSize: 18,width:"180px"}} disabled={tags.length === 0} onClick={tagsStore}>Next
          </Button>
        </Grid>
      </Container>

    </>
  );


}